import { isDebugModeEnabled } from "./testing.js";
function isEventProtocolMessage(message) {
    const { data } = message;
    const isObject = !!data && typeof data === "object";
    return isObject && "kind" in data && data.kind === "EVENT_PROTOCOL";
}
function getEventProtocolMessageOrNull(message) {
    if (isEventProtocolMessage(message)) {
        return message.data;
    }
    else {
        return null;
    }
}
export class RelayWrapper {
    relay;
    constructor(relay) {
        this.relay = relay;
    }
    async emit(type, data) {
        if (isDebugModeEnabled()) {
            return new Promise((resolve, reject) => {
                const handler = async (message) => {
                    const eventProtocolMessage = getEventProtocolMessageOrNull(message);
                    if (eventProtocolMessage == null) {
                        return;
                    }
                    try {
                        await this.replayAndValidate(eventProtocolMessage);
                        resolve();
                    }
                    catch (err) {
                        reject(err);
                    }
                    finally {
                        window.removeEventListener("message", handler);
                    }
                };
                window.addEventListener("message", handler);
                this.relay.emit(type, data);
            });
        }
        else {
            this.relay.emit(type, data);
        }
    }
    async replayAndValidate(message) {
        const result = await fetch(`${message.url}/validate?access_token=${message.token}`, {
            method: "POST",
            body: JSON.stringify([message.event]),
            headers: { "Content-Type": "application/json" },
        });
        if (result.status != 200) {
            throw new Error(`EventProtocol validation failed with unexpected HTTP status ${result.status}`);
        }
        const body = (await result.json().catch(() => ({})));
        if (!body[0]?.valid) {
            const messages = (body[0]?.errors ?? []).map((e) => e.message).join("\n");
            throw new Error(messages);
        }
    }
}
//# sourceMappingURL=relay-wrapper.js.map